<!-- Shipping page form stars  -->
<div class="row">
    <div class="col-xs-12 col-sm-12 col-md-8 p-0 m-0 Registration-split" #target>
        <app-account-header [selectedHeader]="header" [tableCategory]="creditInvoice"></app-account-header>

        <div class="row">
            <div class="col-12 leftmargin">

                <h3 class="pdp-title">
                    {{ "accountRegistration.billingInformation.title" | cxTranslate }}
                </h3>

                <span class="title-sub-heading">{{
          "accountRegistration.title_sub_heading" | cxTranslate
          }}</span>
                <div class="col-xs-12 col-sm-8 col-md-10 p0 account-form">
                    <form [formGroup]="shippingForm" id="shippingAddressForm" (ngSubmit)="proceedToContacts()">
                        <div id="registerBilling" formGroupName="shippingAddress">
                            <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                <div class="marginLeftTop">
                                    <label for="shippingAddressForm.shippingAddress" id="shippingAddress" class="Fields-label-new">{{
                    "accountRegistration.shippingInformation.is_address_same"
                    | cxTranslate
                    }}</label>
                                    <div class="custom-radio-group  label-location">
                                        <input type="radio" id="radio-btn" name="sameAsBillingAddress" [value]="isShippingAddressSame[0]" formControlName="sameAsBillingAddress" (click)="sameasBillingValue(isShippingAddressSame[0])" />
                                        <label class="ctClassForLabel secloct" for="shippingAddressForm.shippingAddress1">
                      {{
                      "accountRegistration.form.yellow_fever.accepted" | cxTranslate
                      }}
                    </label>
                                    </div>
                                    <div class="custom-radio-group label-location">
                                        <input type="radio" id="radio-btn" name="sameAsBillingAddress" [value]="isShippingAddressSame[1]" formControlName="sameAsBillingAddress" (click)="sameasBillingValue(isShippingAddressSame[1])" />
                                        <label class="ctClassForLabel" for="shippingAddressForm.shippingAddress2">
                      {{
                      "accountRegistration.form.yellow_fever.rejected"
                      | cxTranslate
                      }}
                    </label>
                                    </div>
                                    <span class="errorMessage m-0 p-0" *ngIf="sameasBillingValidation">This field is required</span>
                                </div>

                                <ng-template #errorPopContent>{{ "accountRegistration.special_validation_msg_popover" | cxTranslate }}
                                </ng-template>

                                <label for="facilityName" class="Fields-label icon-label">{{
                  "accountRegistration.form.facilityName.label" |
                  cxTranslate }}
                </label>
                                <a placement="top" [ngbPopover]="errorPopContent"><img src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" /></a>
                                <input id="facilityName" name="facilityName" data-valid="valid_facility" maxlength="40" aria-labelledby="shippingAddressForm.facilityName tooltipFacilityName" type="text" [readonly]="
              shippingForm.get('shippingAddress.sameAsBillingAddress').value
            " class="Fields-input" formControlName="facilityName" data-di-id="#shippingAddressForm.facilityName" mdgTextFilter />

                                <span *ngIf="
                  !!shippingForm.get('shippingAddress.facilityName').value &&
                  !shippingForm.get('shippingAddress.facilityName').valid &&
                  shippingForm.get('shippingAddress.facilityName').touched
                " class="errorMessage">{{
                  "accountRegistration.special_validation_msg" | cxTranslate
                  }}</span>
                                <span *ngIf="
                  shippingForm.get('shippingAddress.facilityName').errors
                    ?.required &&
                  !shippingForm.get('shippingAddress.facilityName').valid &&
                  shippingForm.get('shippingAddress.facilityName').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>
                            <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                doubleLineContainer
              ">
                                <label for="formLegalName" class="Fields-label">{{ "accountRegistration.form.facilityName2.label" |
                  cxTranslate }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span>
                </label>
                                <input id="legalName" name="legalName" maxlength="40" data-valid="valid_facility" type="text" [readonly]="
                  shippingForm.get('shippingAddress.sameAsBillingAddress').value
                " class="Fields-input" formControlName="facilityName2" autocomplete="off" data-di-id="#formLegalName" mdgTextFilter />

                                <span *ngIf="
                  !!shippingForm.get('shippingAddress.facilityName2').value &&
                  !shippingForm.get('shippingAddress.facilityName2').valid &&
                  shippingForm.get('shippingAddress.facilityName2').touched
                " class="errorMessage">{{
                  "accountRegistration.special_validation_msg" | cxTranslate
                  }}</span>
                                <span *ngIf="
                  shippingForm.get('shippingAddress.facilityName2').errors?.required &&
                  !shippingForm.get('shippingAddress.facilityName2').valid &&
                  shippingForm.get('shippingAddress.facilityName2').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>

                            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                <label for="formLegalName" class="Fields-label">{{ "accountRegistration.form.attention.label" |
                  cxTranslate
                  }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span>
                </label>
                                <input id="shippingAddress" name="shippingAddress.attention" data-valid="valid_facility" type="text" class="Fields-input" formControlName="attention" [readonly]="
              shippingForm.get('shippingAddress.sameAsBillingAddress').value" maxlength="35" autocomplete="off" data-di-id="#formLegalName" mdgTextFilter />

                                <span *ngIf="
              !!shippingForm.get('shippingAddress.attention').value &&
              !shippingForm.get('shippingAddress.attention').valid &&
              shippingForm.get('shippingAddress.attention').touched
            " class="errorMessage">{{
                  "accountRegistration.special_validation_msg" | cxTranslate
                  }}</span>
                                <span *ngIf="
              shippingForm.get('shippingAddress.attention').errors?.required &&
              !shippingForm.get('shippingAddress.attention').valid &&
              shippingForm.get('shippingAddress.attention').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>


                            <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                <label for="shippingAddressForm.line1" class="Fields-label icon-label">{{
                  "accountRegistration.form.address_line_1.label" | cxTranslate }}
                </label>
                                <a placement="top" [ngbPopover]="errorPopContent">
                                    <img src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" />
                                </a>
                                <input id="shippingAddressForm.line1" name="shippingAddress.line1" data-valid="valid_facility" aria-labelledby="shippingAddressForm.line1 tooltipshippingAddress1" type="text" [readonly]="
                  shippingForm.get('shippingAddress.sameAsBillingAddress').value" class="Fields-input" formControlName="line1" data-di-id="#shippingAddressForm.line1" mdgTextFilter googleAddress (addressChosen)="onShippingAddress($event)" placeholder="Type address…"
                                    autocomplete="off" />

                                <span *ngIf="
                  !!shippingForm.get('shippingAddress.line1').value &&
                  !shippingForm.get('shippingAddress.line1').valid &&
                  shippingForm.get('shippingAddress.line1').touched
                " class="errorMessage">{{
                  "accountRegistration.special_validation_msg" | cxTranslate
                  }}</span>
                                <span *ngIf="
                  shippingForm.get('shippingAddress.line1').errors?.required &&
                  !shippingForm.get('shippingAddress.line1').valid &&
                  shippingForm.get('shippingAddress.line1').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                                <label for="shippingAddressForm.line2" class="Fields-label">{{
                  "accountRegistration.form.address_line_2.label" | cxTranslate
                  }}
                  <span>{{
                    "accountRegistration.optional_tag" | cxTranslate
                    }}</span></label>
                                <input id="shippingAddressForm.line2" name="shippingAddressForm.line2" data-valid="valid_facility" placeholder="Suite/Floor/Building" type="text" [readonly]="shippingForm.get('shippingAddress.sameAsBillingAddress').value" class="Fields-input field-optional"
                                    formControlName="line2" data-di-id="#shippingAddressForm.line2" mdgTextFilter />

                                <span *ngIf="
                  !!shippingForm.get('shippingAddress.line2').value &&
                  !shippingForm.get('shippingAddress.line2').valid &&
                  shippingForm.get('shippingAddress.line2').touched
                " class="errorMessage">{{ "accountRegistration.alpha_numeric_msg" | cxTranslate }}</span>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                                <label for="shippingAddressForm.town" class="Fields-label">{{
                  "accountRegistration.form.city.label" | cxTranslate
                  }}</label>
                                <input id="shippingAddressForm.town" name="shippingAddressForm.town" data-valid="valid_city" type="text" [readonly]="shippingForm.get('shippingAddress.sameAsBillingAddress').value" class="Fields-input" formControlName="town" data-di-id="#shippingAddressForm.town"
                                    mdgTextFilter/>

                                <span *ngIf="
                  !!shippingForm.get('shippingAddress.town').value &&
                  !shippingForm.get('shippingAddress.town').valid &&
                  shippingForm.get('shippingAddress.town').touched
                " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                <span *ngIf="
                  shippingForm.get('shippingAddress.town').errors?.required &&
                  !shippingForm.get('shippingAddress.town').valid &&
                  shippingForm.get('shippingAddress.town').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>

                            <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                asses_dropdown
              ">
                                <label for="shippingAddressForm.state" id="provinceLabel" class="Fields-label">{{
                  "accountRegistration.form.state.label" | cxTranslate
                  }}</label>
                                <div class="">
                                    <div class="" formGroupName="region">
                                        <ng-select [items]="provinces" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select" formControlName="isocode" class="dropdown-credit" [readonly]="shippingForm.get('shippingAddress.sameAsBillingAddress').value"></ng-select>
                                    </div>

                                    <span *ngIf="
                    shippingForm.get('shippingAddress.region.isocode').errors
                      ?.required &&
                    !shippingForm.get('shippingAddress.region.isocode').valid &&
                    shippingForm.get('shippingAddress.region.isocode').touched
                  " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                    "accountRegistration.requiredMsg"
                    | cxTranslate }}
                  </span>
                                </div>
                            </div>
                            <div class="
                col-xs-12 col-sm-12 col-md-12
                p0
                Fields-container
                zip-container
              ">
                                <label for="shippingAddressForm.postalCode" class="Fields-label">{{
                  "accountRegistration.form.zipCode.label" | cxTranslate
                  }}</label>
                                <input id="shippingAddressForm.postalCode" name="shippingAddressForm.postalCode" data-valid="valid_zip_canada" maxlength="10" appZipMask type="text" [readonly]="shippingForm.get('shippingAddress.sameAsBillingAddress').value" class="Fields-input" formControlName="postalCode"
                                    data-di-id="#shippingAddressForm.postalCode" mdgTextFilter />

                                <span *ngIf="
                  shippingForm.get('shippingAddress.postalCode').errors?.pattern &&
                  !shippingForm.get('shippingAddress.postalCode').valid &&
                  shippingForm.get('shippingAddress.postalCode').touched
                " class="errorMessage" role="alert" aria-live="assertive">{{
                  "accountRegistration.PotalCode_Validation_msg"
                  | cxTranslate
                  }}</span>
                                <span *ngIf="
                  shippingForm.get('shippingAddress.postalCode').errors?.required &&
                  !shippingForm.get('shippingAddress.postalCode').valid &&
                  shippingForm.get('shippingAddress.postalCode').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                  cxTranslate }}
                </span>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container small-device">
                                <div class="phone-container">
                                    <label for="formPhone" class="Fields-label">{{
                    "accountRegistration.form.phone.label" | cxTranslate
                    }}</label>
                                    <input id="formPhone" name="shippingAddressForm.phone" data-valid="valid_phone" placeholder="123-456-7890" type="text" maxlength="12" [readonly]="
                    shippingForm.get('shippingAddress.sameAsBillingAddress').value
                  " appPhoneMask class="Fields-input phone-no-mask" formControlName="phone" autocomplete="off" data-di-id="#formPhone" mdgTextFilter />

                                    <span class="errorMessage" *ngIf="
                    !!shippingForm.get('shippingAddress.phone').value &&
                    !shippingForm.get('shippingAddress.phone').valid &&
                    shippingForm.get('shippingAddress.phone').touched
                  ">{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span>
                                    <span *ngIf="
                    shippingForm.get('shippingAddress.phone').errors?.required &&
                    !shippingForm.get('shippingAddress.phone').valid &&
                    shippingForm.get('shippingAddress.phone').touched
                  " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>
                                <div class="phone-container doubleLineContainer">
                                    <label for="shippingAddressForm.extension" class="Fields-label">{{
                    "accountRegistration.form.extension.label" | cxTranslate
                    }}<span>{{
                      "accountRegistration.optional_tag" | cxTranslate
                      }}</span></label>
                                    <input id="shippingAddressForm.extension" name="shippingAddressForm.extension" data-valid="valid_extension" type="text" [readonly]="shippingForm.get('shippingAddress.sameAsBillingAddress').value" (keyup)="validationExtension(shippingForm.get('shippingAddress.extension').value,'extnson')"
                                        class="Fields-input field-optional extension" formControlName="extension" placeholder="-" data-di-id="#shippingAddressForm.extension" maxlength="6" mdgTextFilter />
                                    <span class="errorMessage" *ngIf="extensionErrorMsg">{{
                    "accountRegistration.form.extension.ext_validation_msg"
                    | cxTranslate
                    }}</span>
                                </div>
                            </div>
                            <hr class="Fields-container-line billingPage" />

                            <section class="aboutBilling">
                                <h3 class="mainHeading noUnderline">{{"accountRegistration.form.communication.e_billing" | cxTranslate }}</h3>
                                <p class="aboutBilling__p1 Fields-label-new">{{"accountRegistration.form.communication.aboutBilling__p1" | cxTranslate }}</p>
                                <p class="aboutBilling__p2 Fields-label-new">{{"accountRegistration.form.communication.aboutBilling__p2" | cxTranslate }}</p>
                            </section>
                            <section class="invoice Fields-container d-flex flex-row" style="gap:20px">
                                <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                    <label class="Fields-label" for="invoiceEmail">{{"accountRegistration.form.communication.invoice_email.label" |
                  cxTranslate }}</label>
                                    <div>
                                        <input id="invoiceEmail" name="invoiceEmail" data-valid="valid_invoiceEmail" maxlength="40" aria-labelledby="shippingAddressForm.invoiceEmail tooltipInvoiceEmail" type="text" class="Fields-input" formControlName="invoiceEmail" data-di-id="#shippingAddressForm.invoiceEmail"
                                            mdgTextFilter data-charsfilter="email" />

                                        <span *ngIf="
                                !!shippingForm.get('shippingAddress.invoiceEmail').value &&
                                !shippingForm.get('shippingAddress.invoiceEmail').valid &&
                                shippingForm.get('shippingAddress.invoiceEmail').touched
                              " class="errorMessage">{{"accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span *ngIf="
                                shippingForm.get('shippingAddress.invoiceEmail').errors?.required &&
                                !shippingForm.get('shippingAddress.invoiceEmail').valid &&
                                shippingForm.get('shippingAddress.invoiceEmail').touched
                              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                    </div>
                                </div>
                                <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                    <label class="Fields-label" for="confirmInvoiceEmail">{{"accountRegistration.form.communication.confirm_invoice_email.label" | cxTranslate
                  }}</label>
                                    <input id="confirmInvoiceEmail" name="confirmInvoiceEmail" data-valid="valid_confirmInvoiceEmail" maxlength="40" aria-labelledby="shippingAddressForm.confirmInvoiceEmail tooltipConfirmInvoiceEmail" type="text" class="Fields-input" formControlName="confirmInvoiceEmail"
                                        data-di-id="#shippingAddressForm.confirmInvoiceEmail" mdgTextFilter data-charsfilter="email" />
                                    <div>
                                        <span style="position: relative" *ngIf="
                                  !!shippingForm.get('shippingAddress.confirmInvoiceEmail').value &&
                                  !shippingForm.get('shippingAddress.confirmInvoiceEmail').valid &&
                                  shippingForm.get('shippingAddress.confirmInvoiceEmail').touched
                                " class="errorMessage">{{"accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span style="position: relative" *ngIf="
                                  shippingForm.get('shippingAddress.confirmInvoiceEmail').errors?.required &&
                                  !shippingForm.get('shippingAddress.confirmInvoiceEmail').valid &&
                                  shippingForm.get('shippingAddress.confirmInvoiceEmail').touched
                                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>
                                </div>
                            </section>
                            <section class="accStmnts Fields-container d-flex flex-row" style="gap:20px">
                                <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                    <label class="Fields-label" for="stmntEmail">{{"accountRegistration.form.communication.account_statements_email.label" | cxTranslate
                  }}</label>

                                    <input id="stmntEmail" name="stmntEmail" data-valid="valid_stmntEmail" maxlength="40" aria-labelledby="shippingAddressForm.stmntEmail tooltipInvoiceEmail" type="text" class="Fields-input" formControlName="stmntEmail" data-di-id="#shippingAddressForm.stmntEmail"
                                        mdgTextFilter data-charsfilter="email" />
                                    <div>
                                        <span *ngIf="
                              !!shippingForm.get('shippingAddress.stmntEmail').value &&
                              !shippingForm.get('shippingAddress.stmntEmail').valid &&
                              shippingForm.get('shippingAddress.stmntEmail').touched
                              " class="errorMessage">{{"accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span *ngIf="
                              shippingForm.get('shippingAddress.stmntEmail').errors?.required &&
                              !shippingForm.get('shippingAddress.stmntEmail').valid &&
                              shippingForm.get('shippingAddress.stmntEmail').touched
                              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                    </div>
                                </div>
                                <div class="formElementContainer d-flex flex-column mt-1" style="flex: 1 1 50%;">
                                    <label class="Fields-label" for="confirmStmntEmail">{{"accountRegistration.form.communication.confirm_account_statements_email.label" |
                  cxTranslate }}</label>

                                    <input id="confirmStmntEmail" name="confirmStmntEmail" data-valid="valid_confirmStmntEmail" maxlength="40" aria-labelledby="shippingAddressForm.confirmStmntEmail tooltipInvoiceEmail" type="text" class="Fields-input" formControlName="confirmStmntEmail"
                                        data-di-id="#shippingAddressForm.confirmStmntEmail" mdgTextFilter data-charsfilter="email" />
                                    <div>
                                        <span style="position: relative" class="errorMessage" *ngIf="
                                !!shippingForm.get('shippingAddress.confirmStmntEmail').value &&
                                !shippingForm.get('shippingAddress.confirmStmntEmail').valid &&
                                shippingForm.get('shippingAddress.confirmStmntEmail').touched">{{"accountRegistration.form.email.email_validation_msg" | cxTranslate }}</span>
                                        <span style="position: relative" *ngIf="
                                shippingForm.get('shippingAddress.confirmStmntEmail').errors?.required &&
                                !shippingForm.get('shippingAddress.confirmStmntEmail').valid &&
                                shippingForm.get('shippingAddress.confirmStmntEmail').touched
                              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                    </div>
                                </div>
                            </section>
                            <hr class="Fields-container-line billingPage" />


                            <div class="marginLeftRight">

                                <label for="shippingAddressForm.yellowFever" id="yellowFever" class="Fields-label-new">{{
                  "accountRegistration.financial_responsible.is_financial_responsible" | cxTranslate
                  }}</label>
                                <div class="custom-radio-group  label-location">
                                    <input type="radio" id="radio-btn" name="yellowFeverForShippingAddr" [value]="yellowFever[0]" formControlName="yellowFeverForShippingAddr" (click)="replicateForm('Y')" />
                                    <label class="secloct ctClassForLabel" for="customRadio1">
                    {{
                    "accountRegistration.form.yellow_fever.accepted" | cxTranslate
                    }}
                  </label>
                                </div>
                                <div class="custom-radio-group  label-location">
                                    <input type="radio" id="radio-btn" name="yellowFeverForShippingAddr" [value]="yellowFever[1]" formControlName="yellowFeverForShippingAddr" (click)="replicateForm('N')" />
                                    <label class="ctClassForLabel" for="shippingAddressForm.yellowFever2">
                    {{
                    "accountRegistration.form.yellow_fever.rejected" | cxTranslate
                    }}
                  </label>

                                </div>
                                <span class="errorMessage m-0 p-0" *ngIf="financialResponsibleValidation">This field is required</span>
                            </div>




                            <hr class="Fields-container-line billingPage" />



                            <div id="repeatDiv" *ngIf="!isfinancialResponsible">

                                <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">


                                    <ng-template #errorPopContent>{{ "accountRegistration.special_validation_msg_popover" | cxTranslate }}
                                    </ng-template>

                                    <label for="facilityName" class="Fields-label icon-label">{{
                    "accountRegistration.form.facilityName.label" |
                    cxTranslate }}
                  </label>
                                    <a placement="top" [ngbPopover]="errorPopContent"><img src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" /></a>
                                    <input id="facilityName_repeat" name="facilityName_repeat" data-valid="valid_facility" maxlength="40" aria-labelledby="shippingAddressForm.facilityName tooltipFacilityName" type="text" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')
          " class="Fields-input" formControlName="facilityName_repeat" data-di-id="#shippingAddressForm.facilityName" mdgTextFilter />

                                    <span *ngIf="
                !!shippingForm.get('shippingAddress.facilityName_repeat').value &&
                !shippingForm.get('shippingAddress.facilityName_repeat').valid &&
                shippingForm.get('shippingAddress.facilityName_repeat').touched
              " class="errorMessage">{{
                    "accountRegistration.alpha_numeric_msg" | cxTranslate
                    }}</span>
                                    <span *ngIf="
                shippingForm.get('shippingAddress.facilityName_repeat').errors
                  ?.required &&
                !shippingForm.get('shippingAddress.facilityName_repeat').valid &&
                shippingForm.get('shippingAddress.facilityName_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>
                                <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              doubleLineContainer
            ">
                                    <label for="formLegalName" class="Fields-label">{{ "accountRegistration.form.facilityName2.label" |
                    cxTranslate }}
                    <span>{{
                      "accountRegistration.optional_tag" | cxTranslate
                      }}</span>
                  </label>
                                    <input id="facilityName_repeat2" name="facilityName_repeat2" data-valid="valid_facility" type="text" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" class="Fields-input" formControlName="facilityName_repeat2" autocomplete="off"
                                        data-di-id="#formLegalName" maxlength="40" mdgTextFilter />

                                    <span *ngIf="
                !!shippingForm.get('shippingAddress.facilityName_repeat2').value &&
                !shippingForm.get('shippingAddress.facilityName_repeat2').valid &&
                shippingForm.get('shippingAddress.facilityName_repeat2').touched
              " class="errorMessage">{{
                    "accountRegistration.special_validation_msg" | cxTranslate
                    }}</span>
                                    <span *ngIf="
                shippingForm.get('shippingAddress.facilityName_repeat2').errors?.required &&
                !shippingForm.get('shippingAddress.facilityName_repeat2').valid &&
                shippingForm.get('shippingAddress.facilityName_repeat2').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>



                                <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            doubleLineContainer
          ">
                                    <label for="formLegalName" class="Fields-label">{{ "accountRegistration.form.attention.label" |
                    cxTranslate
                    }}
                    <span>{{
                      "accountRegistration.optional_tag" | cxTranslate
                      }}</span>
                  </label>
                                    <input id="attention_repeat" name="attention_repeat" data-valid="valid_facility" type="text" class="Fields-input" formControlName="attention_repeat" autocomplete="off" maxlength="35" data-di-id="#formLegalName" mdgTextFilter />

                                    <span *ngIf="
              !!shippingForm.get('shippingAddress.attention_repeat').value &&
              !shippingForm.get('shippingAddress.attention_repeat').valid &&
              shippingForm.get('shippingAddress.attention_repeat').touched
            " class="errorMessage">{{
                    "accountRegistration.alpha_numeric_msg" | cxTranslate
                    }}</span>
                                    <span *ngIf="
              shippingForm.get('shippingAddress.attention_repeat').errors?.required &&
              !shippingForm.get('shippingAddress.attention_repeat').valid &&
              shippingForm.get('shippingAddress.attention_repeat').touched
            " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>




                                <div class="
          col-xs-12 col-sm-12 col-md-12
          p0
          Fields-container
          doubleLineContainer
        ">
                                    <label for="shippingAddressForm.line1" class="Fields-label icon-label">{{
                    "accountRegistration.form.address_line_1.label" | cxTranslate }}
                  </label>
                                    <a placement="top" [ngbPopover]="errorPopContent">
                                        <img src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg" class="faq" />
                                    </a>
                                    <input id="line1_repeat" name="line1_repeat" data-valid="valid_facility" aria-labelledby="shippingAddressForm.line1 tooltipshippingAddress1" type="text" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" class="Fields-input"
                                        formControlName="line1_repeat" data-di-id="#shippingAddressForm.line1" mdgTextFilter googleAddress (addressChosen)="onShippingAddress($event, '_repeat')" placeholder="Type address…" autocomplete="off" />

                                    <span *ngIf="
                !!shippingForm.get('shippingAddress.line1_repeat').value &&
                !shippingForm.get('shippingAddress.line1_repeat').valid &&
                shippingForm.get('shippingAddress.line1_repeat').touched
              " class="errorMessage">{{
                    "accountRegistration.special_validation_msg" | cxTranslate
                    }}</span>
                                    <span *ngIf="
                shippingForm.get('shippingAddress.line1_repeat').errors?.required &&
                !shippingForm.get('shippingAddress.line1_repeat').valid &&
                shippingForm.get('shippingAddress.line1_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                                    <label for="shippingAddressForm.line2" class="Fields-label">{{
                    "accountRegistration.form.address_line_2.label" | cxTranslate
                    }}
                    <span>{{
                      "accountRegistration.optional_tag" | cxTranslate
                      }}</span></label>
                                    <input id="shippingAddressForm.line2" name="shippingAddressForm.line2" data-valid="valid_facility" placeholder="Suite/Floor/Building" type="text" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" class="Fields-input field-optional"
                                        formControlName="line2_repeat" data-di-id="#shippingAddressForm.line2" mdgTextFilter />

                                    <span *ngIf="
                !!shippingForm.get('shippingAddress.line2').value &&
                !shippingForm.get('shippingAddress.line2').valid &&
                shippingForm.get('shippingAddress.line2').touched
              " class="errorMessage">{{ "accountRegistration.alpha_numeric_msg" | cxTranslate }}</span>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
                                    <label for="shippingAddressForm.town" class="Fields-label">{{
                    "accountRegistration.form.city.label" | cxTranslate
                    }}</label>
                                    <input id="town_repeat" name="town_repeat" data-valid="valid_city" type="text" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" class="Fields-input" formControlName="town_repeat" data-di-id="#shippingAddressForm.town" mdgTextFilter
                                    />

                                    <span *ngIf="
                !!shippingForm.get('shippingAddress.town_repeat').value &&
                !shippingForm.get('shippingAddress.town_repeat').valid &&
                shippingForm.get('shippingAddress.town_repeat').touched
              " class="errorMessage">{{ "accountRegistration.alpha_space_msg" | cxTranslate }}</span>
                                    <span *ngIf="
                shippingForm.get('shippingAddress.town_repeat').errors?.required &&
                !shippingForm.get('shippingAddress.town_repeat').valid &&
                shippingForm.get('shippingAddress.town_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>

                                <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              asses_dropdown
            ">
                                    <label for="shippingAddressForm.state" id="provinceLabel" class="Fields-label">{{
                    "accountRegistration.form.state.label" | cxTranslate
                    }}</label>
                                    <div class="">
                                        <div class="" formGroupName="region_repeat">
                                            <ng-select [items]="provinces" [searchable]="false" [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select" formControlName="isocode" class="dropdown-credit" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')"></ng-select>
                                        </div>

                                        <span *ngIf="
                  shippingForm.get('shippingAddress.region_repeat.isocode').errors
                    ?.required &&
                  !shippingForm.get('shippingAddress.region_repeat.isocode').valid &&
                  shippingForm.get('shippingAddress.region_repeat.isocode').touched
                " class="errorMessage drop-downs" role="alert" aria-live="assertive">{{
                      "accountRegistration.requiredMsg"
                      | cxTranslate }}
                    </span>
                                    </div>
                                </div>
                                <div class="
              col-xs-12 col-sm-12 col-md-12
              p0
              Fields-container
              zip-container
            ">
                                    <label for="shippingAddressForm.postalCode" class="Fields-label">{{
                    "accountRegistration.form.zipCode.label" | cxTranslate
                    }}</label>
                                    <input id="postalCode_repeat" name="postalCode_repeat" data-valid="valid_zip_canada" maxlength="10" type="text" appZipMask [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" class="Fields-input" formControlName="postalCode_repeat"
                                        data-di-id="#shippingAddressForm.postalCode" mdgTextFilter />

                                    <span *ngIf="
                shippingForm.get('shippingAddress.postalCode_repeat').errors?.pattern &&
                !shippingForm.get('shippingAddress.postalCode_repeat').valid &&
                shippingForm.get('shippingAddress.postalCode_repeat').touched
              " class="errorMessage" role="alert" aria-live="assertive">{{
                    "accountRegistration.alpha_numeric_msg"
                    | cxTranslate
                    }}</span>
                                    <span *ngIf="
                shippingForm.get('shippingAddress.postalCode_repeat').errors?.required &&
                !shippingForm.get('shippingAddress.postalCode_repeat').valid &&
                shippingForm.get('shippingAddress.postalCode_repeat').touched
              " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                    cxTranslate }}
                  </span>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container small-device">
                                    <div class="phone-container">
                                        <label for="formPhone" class="Fields-label">{{
                      "accountRegistration.form.phone.label" | cxTranslate
                      }}</label>
                                        <input id="phone_repeat" name="phone_repeat" data-valid="valid_phone" placeholder="123-456-7890" type="text" maxlength="12" [readonly]="!shippingForm.get('shippingAddress.yellowFeverForShippingAddr')" appPhoneMask class="Fields-input phone-no-mask" formControlName="phone_repeat"
                                            autocomplete="off" data-di-id="#formPhone" mdgTextFilter />

                                        <span class="errorMessage" *ngIf="
                  !!shippingForm.get('shippingAddress.phone_repeat').value &&
                  !shippingForm.get('shippingAddress.phone_repeat').valid &&
                  shippingForm.get('shippingAddress.phone_repeat').touched
                ">{{ "accountRegistration.form.phone.ph_validation_msg" | cxTranslate }}</span>
                                        <span *ngIf="
                  shippingForm.get('shippingAddress.phone_repeat').errors?.required &&
                  !shippingForm.get('shippingAddress.phone_repeat').valid &&
                  shippingForm.get('shippingAddress.phone_repeat').touched
                " class="defaultMessage" role="alert" aria-live="assertive">{{ "accountRegistration.requiredMsg" |
                      cxTranslate }}
                    </span>
                                    </div>
                                    <div class="phone-container doubleLineContainer">
                                        <label for="shippingAddressForm.extension" class="Fields-label">{{
                      "accountRegistration.form.extension.label" | cxTranslate
                      }}<span>{{
                        "accountRegistration.optional_tag" | cxTranslate
                        }}</span></label>
                                        <input id="shippingAddressForm.extension_repeat" name="shippingAddressForm.extension_repeat" data-valid="valid_extension" type="text" class="Fields-input field-optional extension" formControlName="extension_repeat" maxlength="6" placeholder="-" (keyup)="validationExtension(shippingForm.get('shippingAddress.extension_repeat').value,'extnson_rpt')"
                                            data-di-id="#shippingAddressForm.extension_repeat" mdgTextFilter />

                                        <span class="errorMessage" *ngIf="extensionrepeatErrorMsg">{{
                      "accountRegistration.form.extension.ext_validation_msg"
                      | cxTranslate
                      }}</span>
                                    </div>
                                </div>

                            </div>





                        </div>
                        <div class="invoice-btngrps">
                            <button type="button" (click)="back()" class="btn-secondary" data-di-id="di-id-7a6cb2cd-cb37948a">
                {{ "accountRegistration.form.back_button" | cxTranslate }}
              </button>
                            <button type="submit" class="btn-primary" data-di-id="di-id-7a6cb2cd-cb37948a">
                {{ "accountRegistration.form.continue_button" | cxTranslate }}
              </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>





    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 needCls needCls2 Notify-Msg" [innerHTML]="(finalAssistanceContent | async)?.content">
    </div>
</div>
<!-- shipping form ends -->
